import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { InputForm } from '../../../shared/components/form_components/input';
import { TextAreaForm } from '../../../shared/components/form_components/field';
import { FormGroup } from '../../../shared/components/form_components/group';
import { InputToggle } from '../../../shared/components/form_components/toggle';
import { TitulacoesQuery_titulacoes } from '../../graphql/queries/__generated__/TitulacoesQuery';
import { InputSelect } from '../../../shared/components/form_components/select';

interface Props {
  professor?: FormProfessor;
  titulacoes?: TitulacoesQuery_titulacoes[];
  onSubmit: (disciplina: FormProfessor) => void;
  onCancel?: () => void;
}

interface FormProfessor {
  id_professor?: number;
  dsc_nome_professor: string;
  dsc_email: string;
  dsc_email2: string;
  dsc_email3: string;
  dsc_num_telefone: string;
  dsc_num_telefone2: string;
  dsc_titulacao: string;
  flag_casa: boolean;
  dsc_bio: string;
  dsc_link_linkedin: string;
  dsc_link_twitter: string;
  dsc_link_facebook: string;
  dsc_link_lattes: string;
  dsc_link_instagram: string;
}

const FormularioProfessor: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_professor',
      label: 'Id do professor',
      type: 'number',
      defaultValue: props.professor?.id_professor,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'dsc_nome_professor',
      label: 'Nome do professor',
      type: 'text',
      defaultValue: props.professor?.dsc_nome_professor,
      required: true,
      component: InputForm,
    },
    {
      name: 'dsc_email',
      label: 'Email',
      type: 'email',
      defaultValue: props.professor?.dsc_email,
      required: true,
      component: InputForm,
    },
    {
      name: 'dsc_email2',
      label: 'Email 2',
      type: 'email',
      defaultValue: props.professor?.dsc_email2,
      required: false,
      component: InputForm,
    },
    {
      name: 'dsc_email3',
      label: 'Email 3',
      type: 'email',
      defaultValue: props.professor?.dsc_email3,
      required: false,
      component: InputForm,
    },
    {
      name: 'group_telefones',
      type: 'group',
      sub_fields: [
        {
          name: 'dsc_num_telefone',
          label: 'Telefone',
          type: 'text',
          defaultValue: props.professor?.dsc_num_telefone,
          masks: ['(99) 9 9999-9999'],
          required: true,
          component: InputForm,
        },
        {
          name: 'dsc_num_telefone2',
          label: 'Telefone 2',
          type: 'tel',
          defaultValue: props.professor?.dsc_num_telefone2,
          masks: ['(99) 9 9999-9999'],
          required: false,
          component: InputForm,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'group_titulacao_casa',
      type: 'group',
      sub_fields: [
        {
          name: 'dsc_titulacao',
          label: 'Titulação',
          type: 'text',
          defaultValue: props.professor?.dsc_titulacao,
          items: props.titulacoes?.map((t) => ({
            label: t.dsc_titulacao,
            value: t.dsc_titulacao,
          })),
          required: true,
          readOnly: true,
          component: InputSelect,
        },
        {
          name: 'flag_casa',
          label: 'Casa',
          id: 'professor_flag_casa',
          type: 'checkbox',
          defaultChecked: props.professor?.flag_casa,
          component: InputToggle,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'dsc_bio',
      label: 'Biografia',
      type: 'text',
      defaultValue: props.professor?.dsc_bio,
      maxLength: 500,
      component: TextAreaForm,
    },
    {
      name: 'group_redes_1',
      type: 'group',
      sub_fields: [
        {
          name: 'dsc_link_linkedin',
          label: 'Perfil linkedin',
          type: 'url',
          defaultValue: props.professor?.dsc_link_linkedin,
          component: InputForm,
        },
        {
          name: 'dsc_link_twitter',
          label: 'Perfil twitter',
          type: 'url',
          defaultValue: props.professor?.dsc_link_twitter,
          component: InputForm,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'group_redes_2',
      type: 'group',
      sub_fields: [
        {
          name: 'dsc_link_facebook',
          label: 'Perfil facebook',
          type: 'text',
          defaultValue: props.professor?.dsc_link_facebook,
          component: InputForm,
        },
        {
          name: 'dsc_link_lattes',
          label: 'Perfil lattes',
          type: 'text',
          defaultValue: props.professor?.dsc_link_lattes,
          component: InputForm,
        },
      ],
      component: FormGroup,
    },
    {
      name: 'dsc_link_instagram',
      label: 'Perfil instagram',
      type: 'text',
      defaultValue: props.professor?.dsc_link_instagram,
      component: InputForm,
    },
  ];

  return (
    <Form
      fields={fields}
      form_name='professor'
      is_edit={Boolean(props.professor)}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  );
};

export { FormularioProfessor };
export type { FormProfessor };
